import React, { useState, useRef,useEffect } from "react";
import { signInWithPopup } from "firebase/auth";
import { auth, provider, db } from "../firebase";
import {jwtDecode} from "jwt-decode";
import { Box } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import TopAppBar from "./TopAppBar";
import ChatArea from "./ChatArea";
import ChatInput from "./ChatInput";
import PdfViewer from "./PdfViewer";
import SystemDrawer from "./SystemDrawer";
import FileDrawer from "./FileDrawer";
import LoginButton from "../LoginButton";
import { downloadPdfFromBase64 } from "./FileDownload";
import { APP_BAR_HEIGHT } from "../constants/layout";
import { GoogleGenAI } from "@google/genai";

/* ---------------- Gemini Client ---------------- */

export default function ChatPage() {
  
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const [leftWidth, setLeftWidth] = useState(50); // %
  const [dragging, setDragging] = useState(false);
  const [fileDrawer, setfileDrawer] = useState(false);
  const containerRef = useRef(null);
  const [files,setFiles] = useState([]);
  const [fileFetched,setFileFetched] = useState(false);
  const [userDetail,setUserDetail] =useState(null)
  const [userToken, setUserToken] = useState(null);
  const [isPdfVisible, setIsPdfVisible] = useState(true);
  const [current_pdf,setCurrentPdf] = useState(null);

  // const handleDownload = async(idx) => {
  //   const file = files[idx];
  //   if(files[idx].content){
  //     console.log(files[idx])
  //     downloadPdfFromBase64(files[idx].content,files[idx].name)
      
  //   }
  //   else{
  //     console.log(files[idx].uri)
  //     const content = await downloadContent(files[idx].uri)
  //     setFiles((prevFiles) =>
  //       prevFiles.map((file) =>
  //         file.uri === files[idx].uri
  //           ? { ...file, content: content }
  //           : file
  //       )
        
  //     );
  //     downloadPdfFromBase64(content,files[idx].name)
      
  //   }
  // };
  const handleDownload = async (idx) => {
  setLoading(true);
  try {
    const file = files[idx];

    if (file.content) {
      downloadPdfFromBase64(file.content, file.name);
    } else {
      const content = await downloadContent(file.uri);

      setFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.uri === file.uri ? { ...f, content } : f
        )
      );

      downloadPdfFromBase64(content, file.name);
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const select_pdf = async (idx) => {
  setLoading(true);
  try {
    const file = files[idx];

    if (file.content) {
      setCurrentPdf(file);
    } else {
      const content = await downloadContent(file.uri);

      setFiles((prevFiles) =>
        prevFiles.map((f) =>
          f.uri === file.uri ? { ...f, content } : f
        )
      );

      setCurrentPdf({
        ...file,
        content,
      });
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  // const select_pdf = async(idx)=>{
  //   setLoading(true);
  //   const file = files[idx];
  //   if(files[idx].content){
  //     console.log(files[idx])
  //     setCurrentPdf(files[idx]);
  //   }
  //   else{
  //     console.log(files[idx].uri)
  //     const content = await downloadContent(files[idx].uri)
  //     setFiles((prevFiles) =>
  //       prevFiles.map((file) =>
  //         file.uri === files[idx].uri
  //           ? { ...file, content: content }
  //           : file
  //       )
        
  //     );
  //     setCurrentPdf({
  //       ...file,
  //       content
  //     });
  //   }
    
  // }
  const togglePdf = () => {
    // setIsPdfVisible((prev) => !prev);
    if(leftWidth==0){
      setLeftWidth(50)
    }
    else{
      setLeftWidth(0)
    }
    
  };
  const fetch_files = async()=>{
    const CLOUD_RUN_UPLOAD_URL = "https://list-storage-bucket-files-188976723880.europe-west1.run.app"
    const id_token = sessionStorage.getItem('id_token')
    const response = await fetch(CLOUD_RUN_UPLOAD_URL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${id_token}`, // Google ID token or your JWT
        },
        
      });
    const data = await response.json();
    setFiles(data.file_data);
    setFileFetched(true);

  };
  const handleLogin = (credentialResponse) => {
    
    // if (!credentialResponse?.credential) {
    //   console.error("No credential received");
    //   return;
    // }
    sessionStorage.setItem("id_token", credentialResponse);
    // const decoded = jwtDecode(credentialResponse);
    // console.log(decoded)
    // sessionStorage.setItem('id_token',decoded)
    // setUserToken(decoded);
    verifyToken(credentialResponse)
  };
  const verifyToken = async (googleToken) => {
    const res = await fetch("https://verify-token-188976723880.europe-west1.run.app", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: googleToken })
      });
    
    const data = await res.json();
    
    if (data.valid) {
      setUserToken(googleToken);
      let decoded =jwtDecode(googleToken);
      setUserDetail(data.user);
       if (!auth.currentUser) {
        await signInWithPopup(auth, provider);
        console.log("firebase",auth.currentUser);

      }
      fetch_files();
    }
    
    return;
  };
  useEffect(() => {
    const token = sessionStorage.getItem("id_token");
    if (token) {

      verifyToken(token)

    }
  }, []);
  if (!userToken) {
    return (
      <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <LoginButton onSuccess={handleLogin} />
      </div>
    );
  }

  const downloadContent = async (uri) => {
    try {
      const id_token = sessionStorage.getItem('id_token')
      
      const CLOUD_RUN_UPLOAD_URL = "https://download-file-188976723880.europe-west1.run.app"
      let body={
        "uri":uri
      }
      const response = await fetch(CLOUD_RUN_UPLOAD_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${id_token}`, // Google ID token or your JWT
        },
        body: JSON.stringify(body),
      });
      const contentType = response.headers.get("content-type");
      const data = await response.json();   // ✅ parse JSON
      console.log(data)
    let content = data.file_data;          // ✅ string
    return content

      
    } catch (error) {
      console.error("Gemini Error:", error);
      return "⚠️ Failed to generate response. Please try again.";
    }
  };
  const handleMouseDown = () => {
    setDragging(true);
  };
  const handleDrawChange = () => {
    setfileDrawer(!fileDrawer);
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    const container = containerRef.current;
    const rect = container.getBoundingClientRect();
    const newWidth = ((e.clientX - rect.left) / rect.width) * 100;

    if (newWidth > 25 && newWidth < 75) {
      setLeftWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    setDragging(false);
  };
  const callGemini = async (userMessage) => {
    try {
      const id_token = sessionStorage.getItem('id_token')
      
      const CLOUD_RUN_UPLOAD_URL = "https://chat-188976723880.europe-west1.run.app"
      let body={
        "query":userMessage
      }
      const response = await fetch(CLOUD_RUN_UPLOAD_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${id_token}`, // Google ID token or your JWT
        },
        body: JSON.stringify(body),
      });
      const contentType = response.headers.get("content-type");
      const data = await response.json();   // ✅ parse JSON
      console.log(data)
    let html = data.text;          // ✅ string
    console.log(html)
    console.log(typeof html)
    if(typeof html === "string"){
      let message_body={
        "text" : html.replace("```html", "").replace("```",""),
        "type":"message"
      }
      return message_body

    }
    else{
      if(html.guid){
        let message_body={
          "text" : html,
          "type":"question_paper"
        }
        return message_body
      }
      let message_body={
        "text" : html,
        "type":"code"
      }
      return message_body
    }

      
    } catch (error) {
      console.error("Gemini Error:", error);
      return "⚠️ Failed to generate response. Please try again.";
    }
  };
  const handleSend = async(content) => {
    if (!content) return;
    setMessages((prev) => [
      ...prev,
      { role: "user", content },
      {
        role: "assistant",
        
        content: {
          "text" : "<em>Thinking...</em>",
          "type":"message"
        }
      },
    ]);
    const aiResponse = await callGemini(content);

    // Replace loading with actual response
    setMessages((prev) => {
      const updated = [...prev];
      updated[updated.length - 1] = {
        role: "assistant",
        
        content: aiResponse, // HTML allowed
      };
      return updated;
    }); 
  };

  return (
    <Box
      ref={containerRef}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f7f9fc",
        userSelect: dragging ? "none" : "auto",
      }}
    >
      <TopAppBar onSystemOpen={handleDrawChange} userDetail={userDetail}/>
      <FileDrawer open={fileDrawer} onClose={handleDrawChange} onFileSelect = {select_pdf} onDownload={handleDownload} files={files}/>
      {/* Main Split Area */}
      <Box sx={{ flex: 1, display: "flex", overflow: "hidden" , height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
    mt: `${APP_BAR_HEIGHT}px`,}}>
        
        {/* LEFT - PDF */}
        {/* <Box
          sx={{
            width: `${leftWidth}%`,
            height: "100%",
            borderRight: "1px solid #e0e0e0",
            pointerEvents: dragging ? "none" : "auto",
          }}
        >
          <PdfViewer />
        </Box> */}
        
  <Box
    sx={{
      width: `${leftWidth}%`,
      height: "100%",
      borderRight: "1px solid #e0e0e0",
      pointerEvents: dragging ? "none" : "auto",
      position: "relative",
    }}
  >
    {/* Collapse Button */}
    <Box
      onClick={togglePdf}
      sx={{
        position: "absolute",
        top: "50%",
        right: "-14px",
        transform: "translateY(-50%)",
        zIndex: 10,
        background: "#1565c0",
        color: "#fff",
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: 2,
        "&:hover": {
          background: "#0d47a1",
        },
      }}
    >
      ❮
      
    </Box>
      {(leftWidth>0)?(<PdfViewer pdfBase64={current_pdf?current_pdf.content:null}/>):null}
  </Box>



        {/* DRAG HANDLE */}
        <Box
          onMouseDown={handleMouseDown}
          sx={{
            width: "6px",
            cursor: "col-resize",
            background: dragging ? "#1565c0" : "#e0e0e0",
            "&:hover": { background: "#1565c0" },
          }}
        />

        {/* RIGHT - CHAT */}
        <Box
          sx={{
            width: `${100 - leftWidth}%`,
            display: "flex",
            
            flexDirection: "column",
          }}
        >
          <ChatArea messages={messages} />
          <ChatInput onSend={handleSend} />
        </Box>
      </Box>
      <Backdrop
  sx={{
    color: "#fff",
    zIndex: (theme) => theme.zIndex.modal + 1,
    backgroundColor: "rgba(0,0,0,0.5)", // transparent black
  }}
  open={loading}
>
  <CircularProgress color="inherit" />
</Backdrop>
    </Box>
  );
}
